// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1e0rS","content":"styles_content__1rIdJ"};